import axios from 'axios'

const multipartFormHeaders = {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
}

export default {

  /* - Users - */
  makeAdmin: (id) => axios.put(`/users/${id}/upgrade_to_admin`, {}),
  getUsers: (page = 1, pagination = true, filters = {}) => axios.get('/users', { params: { page: page, pagination: pagination, ...filters }, headers: { 'cache-control': 'no-cache' } }),
  getUsersAll: (page = 1, pagination = true, filters = {}) => axios.get('/users/all', { params: { page: page, pagination: pagination, ...filters } }),
  getUser: (id) => axios.get(`/users/${id}`),
  getUserByInvitation: (token) => axios.get(`/users/invitation/${token}`),
  getUserTerms: (token) => axios.get(`/legal_documents/invitation/${token}`),
  getExportUsers: () => {
    const config = {
      responseType: 'blob'
    }
    return axios.get('/users/export_all', config)
  },
  postUsers: user => axios.post('/users', user),
  putUser: (id, updatedUser) => axios.put(`/users/${id}`, updatedUser),
  deleteUser: (id) => axios.delete(`/users/${id}`),
  reinviteUser: (id) => axios.put(`/users/${id}/invite`, {}),
  putOfficesUsers: (officeId, invitations) => axios.put(`/offices/${officeId}/users`, invitations),
  putActivateUser: (id) => axios.put(`/users/${id}/active`, {}),
  putArchiveUser: (id) => axios.put(`/users/${id}/archive`, {}),
  createMassiveImport: (data) => axios.post('/user_massive_imports', data, multipartFormHeaders),
  confirmMassiveImport: (id) => axios.put(`/user_massive_imports/${id}/confirm`),
  putUserPassword: (id, changePasswordInfo) => axios.put(`/users/${id}/update_password`, changePasswordInfo),
  putCreateUserPasscode: (id, passcodeData) => axios.put(`/users/${id}/create_passcode`, passcodeData),
  putUpdateUserPasscode: (id, passcodeData) => axios.put(`/users/${id}/update_passcode`, passcodeData),
  postUserProfilePicture: (picture) => axios.post(`/users/profile_picture`, picture),
  getUserProfilePicutre: (id) => axios.get(`/users/profile_picture`),
  postCommercial: (commercialData) => axios.post('/users/commercial', commercialData), // Superadmin only
  putForceUpdatePasscode: (userId, newPasscode) => axios.put(`/users/${userId}/passcode`, newPasscode),
  putRequestResetPasscode: (userId) => axios.put(`/users/${userId}/request_passcode`, {}),
  putResetPasscode: (userId, newTokenData) => axios.put(`/users/${userId}/reset_passcode`, newTokenData),
  getUserByPasscodeToken: (passcodeToken) => axios.get(`users/passcode_token/${passcodeToken}`),
  postSuperBookkeeper: (superBookKeeperData) => axios.post('/users/super_bookkeeper', superBookKeeperData),
  /* User Budget s */
  getUserBudgets: (page = 1, pagination = false, filters = {}) => {
    return axios.get(`/user_budgets`, { params: { page: page, pagination: pagination, ...filters } })
  },
  /* Search users for budget */
  getUsersForBudgets: (officeId, filters) => axios.get(`/offices/${officeId}/budget_users`, { params: { ...filters } }),

  /* Profile Settings (Notifications) */
  getUserSettingNotifications: () => axios.get(`/setting_notifications`),
  postUserSettingNotifications: (settings) => axios.post(`/setting_notifications`, settings),

  /* - One Time Password (currently only for super admin critical operations) */
  putUserGenerateOneTimePassword: (userId) => axios.put(`/users/${userId}/otp`, {}),
  /* Convert user without cards to user with cards */
  putConvertUserToCardsUser: (userId, userData) => axios.put(`users/${userId}/to_card_user`, userData)

}
